<template>
  <div class="accueilPage">
    <div class="container ">
      <div class="card shadow-lg p-4">

        <h2 class="text-center mb-4">Eco-bois by Wicco services srl</h2>
        <p class="lead text-center mb-5 fst-italic text-secondary">
          Une entreprise familiale depuis 2018, animée par la passion du bois de qualité.
        </p>

        <div class="row align-items-center">
          <div class="col-md-6 mb-3">
            <img src="@/assets/home.jpg" alt="Grumes" class="img-fluid rounded shadow " />
          </div>

          <div class="col-md-6">


            <div class="row g-4">
              <div class="col-md-4 text-center">
                <div class="p-3 border rounded bg-white h-100">
                  <h3 class="text-success mb-3">
                    🌲 <strong>Bois 100% belge</strong>
                  </h3>
                  <p class="text-muted">
                    Nous sélectionnons exclusivement du bois belge, soigneusement séché, pour garantir une chaleur
                    durable, performante et respectueuse de l’environnement.
                  </p>
                </div>
              </div>

              <div class="col-md-4 text-center">
                <div class="p-3 border rounded bg-white h-100">
                  <h3 class="text-success mb-3">
                    🔥 <strong>Bois adapté à tous vos besoins</strong>
                  </h3>
                  <p class="text-muted">
                    Bûches en différentes longueurs, bois d’allumage et grumes. Nous avons le bois qu’il vous faut,
                    quelle que soit votre utilisation.
                  </p>
                </div>
              </div>

              <div class="col-md-4 text-center">
                <div class="p-3 border rounded bg-white h-100">
                  <h3 class="text-success mb-3">
                    🚚 <strong>Livraison en vrac</strong>
                  </h3>
                  <p class="text-muted">
                    Livraison rapide et gratuite par minimum 3 stères et dans un rayon de 10 km autour de notre dépôt de
                    Malèves-Sainte-Marie (Perwez). Au-delà, nous livrons jusqu’à 50 km. Demandez votre tarif
                    personnalisé.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p class="mt-5 text-center text-secondary fst-italic">
          Chez Eco-bois, la qualité, la proximité et la flexibilité sont au cœur de notre engagement.
        </p>
        <div class="col-md-12 text-center">
          <a href="/public/contact" class="btn btn-primary ">
            Nous contacter
          </a>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'AccueilPage',
  components: {
  }
}
</script>
